import React from 'react'

const ChannelHashTag: React.FC<{ fill?: string, width?: number, height?: number }> = ({ fill, width, height }) => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.35149 15.7143L3.96007 12.2857H0.531494L0.831495 10.5714H4.26007L5.16864 5.42856H1.74007L2.04006 3.71428H5.46864L6.0772 0.285706H7.7915L7.18292 3.71428H12.3258L12.9344 0.285706H14.6486L14.0401 3.71428H17.4687L17.1686 5.42856H13.7401L12.8315 10.5714H16.2601L15.96 12.2857H12.5315L11.9229 15.7143H10.2086L10.8172 12.2857H5.67435L5.06578 15.7143H3.35149ZM6.88292 5.42856L5.97435 10.5714H11.1172L12.0258 5.42856H6.88292Z"
        fill={fill ? fill : "#666666"} />
    </svg>

  )
}

export default ChannelHashTag